import React from 'react';
import { Description } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { IconContainerStyled, MessageStyled, TextContainerStyled, TitleStyled, WrapperStyled } from './styles';

interface NoDataPlaceholderProps {
  text: React.ReactNode;
  title?: string;
  'data-test-id'?: string;
  className?: string;
}

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = (props) => {
  const dataTestId = props['data-test-id'] as string;
  return (
    <WrapperStyled data-test-id={dataTestId} className={props.className}>
      <IconContainerStyled>
        <Description height="4.2rem" width="4.2rem" color={colors.neutral[500]} />
      </IconContainerStyled>
      <TextContainerStyled>
        {props.title && <TitleStyled>{props.title}</TitleStyled>}
        <MessageStyled $hasTitle={!!props.title}>{props.text}</MessageStyled>
      </TextContainerStyled>
    </WrapperStyled>
  );
};

export default NoDataPlaceholder;
